import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import MuiInputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import Input from '../Input/Input.js';
import { useMeasurementUnitsByType } from '../../utils/measurementUnits.js';

const _InputAdornment = styled(MuiInputAdornment) `
  max-height: none;
  height: 100%;
  margin: 0;
  ${({ theme }) => `
    transition: color ${theme.transitions.duration.fast} linear, background-color ${theme.transitions.duration.fast} linear, border ${theme.transitions.duration.fast} linear;
    background-color: ${theme.palette.N40.main};
    color: ${theme.palette.N30.main};
    font-family: ${theme.typography.subtitle4.fontFamily};
    font-size: ${theme.typography.subtitle4.fontSize};
    font-weight: ${theme.typography.subtitle4.fontWeight};
    text-transform: ${theme.typography.subtitle4.textTransform};
  `}
  &.MuiInputAdornment-positionStart {
    border-radius: 4px 0 0 4px;
  }
  &.MuiInputAdornment-positionEnd {
    border-radius: 0 4px 4px 0;
  }
`;
const _Input = styled(Input) `
  line-height: unset;
  border-radius: 5px;
  ${({ theme }) => `
    padding: ${theme.spacing(0)};
    &:hover {
      .MuiInputAdornment-root {
        color: ${theme.palette.N20.main};
      }
    }
    &:focus-within {
      .MuiInputAdornment-root {
        color: ${theme.palette.N20.main};
      }
      :before {
        border-color: ${theme.palette.primary.main};
      }
      input::placeholder {
        opacity: 0;
      }
    }
    .MuiInputAdornment-root {
      padding: ${theme.spacing(0, 1)} !important;
    }
    &.Mui-disabled: {
      .MuiInputAdornment-root {
        color: ${theme.palette.N30.main};
        background-color: ${theme.palette.N60.main};
      }
    },
    &.Mui-error {   
      input::placeholder {
        opacity: 1;
        color: ${theme.palette.error.main};
      }
      .MuiInputAdornment-root {
        color: ${theme.palette.N30.main};
      }
      :before {
        border-color: ${theme.palette.error.main};
      }
    }
    .MuiInputBase-adornedStart .MuiInput-input {
      padding: ${theme.spacing(0, 1.25)};
    }
    .MuiInputBase-adornedEnd .MuiInput-input {
      padding: ${theme.spacing(0, 1.25)};
    }
    .MuiInputAdornment-root {
      padding: ${theme.spacing(2, 1)};
    }
    .MuiInput-input {
      padding: ${theme.spacing(0, 1.25)};
    }
    &.Mui-disabled {
      background-color: ${theme.palette.N80.main};
      .MuiInputAdornment-root {
        background-color: ${theme.palette.N60.main};
        color: ${theme.palette.N30.main};
      }
    }
  `}
`;
const MeasurementInput = (_a) => {
    var { contextUnit, label, value, position = 'end' } = _a, rest = __rest(_a, ["contextUnit", "label", "value", "position"]);
    const measurementUnit = useMeasurementUnitsByType(contextUnit);
    const { label: _label, position: _position } = (measurementUnit === null || measurementUnit === void 0 ? void 0 : measurementUnit.label) && (measurementUnit === null || measurementUnit === void 0 ? void 0 : measurementUnit.position) && measurementUnit ? measurementUnit : { label, position };
    const adornment = useMemo(() => {
        if (_label === undefined || _position === undefined)
            return null;
        return (jsx(_InputAdornment, Object.assign({ disableTypography: true, disablePointerEvents: true, position: _position }, { children: _label })));
    }, [_label, _position]);
    return (jsx(_Input, Object.assign({ type: "number", startAdornment: _position === 'start' ? adornment : null, endAdornment: _position === 'end' ? adornment : null, value: value }, rest)));
};

export { MeasurementInput as default };
//# sourceMappingURL=MeasurementInput.js.map
